import script from "./CertificatePreview.vue?vue&type=script&setup=true&lang=js"
export * from "./CertificatePreview.vue?vue&type=script&setup=true&lang=js"

import "./CertificatePreview.vue?vue&type=style&index=0&id=21ee3e90&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-21ee3e90"]])

export default __exports__